var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoredMekomeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 126,
    height: 24,
    viewBox: "0 0 126 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "m2dfhx4z9a",
    d: "M0 0.083L6.416 0.083 6.416 6.5 0 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bndj994nkb",
    d: "M0.781 0.674L16.459 0.674 16.459 16.352 0.781 16.352z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0hdf1uw6sd",
    d: "M0.043 0.675L15.517 0.675 15.517 16.352 0.043 16.352z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wxsg4o90kf",
    d: "M0.1 0.675L15.574 0.675 15.574 16.352 0.1 16.352z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "px9k23yvsh",
    d: "M0.294 0.504L14.485 0.504 14.485 19.077 0.294 19.077z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2837AA",
    d: "M6.5 3.25c0 1.795-1.455 3.25-3.25 3.25S0 5.045 0 3.25 1.455 0 3.25 0 6.5 1.455 6.5 3.25",
    transform: "translate(-657 -248) translate(510 206) translate(147 42) translate(0 1) translate(118.3 4.117)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-657 -248) translate(510 206) translate(147 42) translate(0 1) translate(118.3 4.117) translate(0 10.4)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7896D2",
    d: "M124.716 17.808c0 1.772-1.436 3.209-3.208 3.209-1.771 0-3.208-1.437-3.208-3.209 0-1.771 1.437-3.208 3.208-3.208 1.772 0 3.208 1.437 3.208 3.208",
    transform: "translate(-657 -248) translate(510 206) translate(147 42) translate(0 1)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-657 -248) translate(510 206) translate(147 42) translate(0 1) translate(0 .217) translate(54.506 3.584)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3hdug29ezc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bndj994nkb"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2837AA",
    d: "M8.62 3.853c-2.57 0-4.661 2.09-4.661 4.66 0 2.57 2.09 4.66 4.66 4.66 2.57 0 4.66-2.09 4.66-4.66 0-2.57-2.09-4.66-4.66-4.66m0 12.5c-4.322 0-7.838-3.518-7.838-7.84S4.297.673 8.62.673c4.323 0 7.84 3.518 7.84 7.84s-3.517 7.84-7.84 7.84",
    mask: "url(#3hdug29ezc)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-657 -248) translate(510 206) translate(147 42) translate(0 1) translate(0 .217) translate(96.386 3.584)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "slbiqzfm6e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0hdf1uw6sd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7896D2",
    d: "M7.762 3.896c-2.238 0-3.652 1.583-4.182 2.938l-.093.233h8.646l-.09-.233c-.72-1.84-2.322-2.938-4.281-2.938m.12 12.456c-2.163 0-4.253-.912-5.733-2.5-1.5-1.61-2.242-3.707-2.085-5.905.275-3.91 3.562-7.1 7.48-7.266.113-.005.223-.006.333-.006 3.248 0 6.037 2.031 7.281 5.303.567 1.49.294 3.533.292 3.554-.002.118-.067.195-.149.195H3.42l.075.225c.624 1.902 2.388 3.179 4.389 3.179 1.326 0 2.589-.57 3.464-1.563.027-.03.064-.048.105-.048.023 0 .055.005.087.031l2.325 1.796c.03.025.05.059.054.097.004.042-.008.082-.035.115-1.493 1.775-3.678 2.793-6 2.793",
    mask: "url(#slbiqzfm6e)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-657 -248) translate(510 206) translate(147 42) translate(0 1) translate(0 .217) translate(23.165 3.584)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6ziqgu2oag",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wxsg4o90kf"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2837AA",
    d: "M7.818 3.896c-2.237 0-3.652 1.583-4.182 2.938l-.093.233h8.646l-.09-.233c-.72-1.84-2.32-2.938-4.28-2.938m.12 12.456c-2.164 0-4.254-.912-5.734-2.5-1.5-1.61-2.241-3.707-2.085-5.905.276-3.91 3.562-7.1 7.481-7.266.112-.005.223-.006.333-.006 3.247 0 6.036 2.031 7.28 5.303.567 1.49.295 3.533.292 3.554-.001.118-.067.195-.148.195H3.475l.075.225c.624 1.902 2.389 3.179 4.39 3.179 1.325 0 2.588-.57 3.463-1.563.027-.03.064-.048.105-.048.023 0 .056.005.087.031l2.325 1.796c.031.025.05.059.055.097.004.042-.009.082-.036.115-1.492 1.775-3.678 2.793-6 2.793",
    mask: "url(#6ziqgu2oag)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2837AA",
    d: "M20.832 10.34c0-3.36-2.723-6.082-6.082-6.082-1.697 0-3.231.695-4.335 1.818-1.102-1.123-2.637-1.818-4.333-1.818-.943 0-1.834.214-2.63.597l-.707-.711c-.059-.059-.138-.092-.221-.092H.31c-.172 0-.31.14-.31.31v15.264c0 .17.138.31.31.31h2.916c.171 0 .31-.14.31-.31V9.89c.213-1.214 1.27-2.138 2.546-2.138 1.43 0 2.586 1.158 2.586 2.588h.01v9.439c0 .087.07.156.156.156h3.18c.088 0 .159-.07.159-.156v-9.613c.088-1.347 1.207-2.414 2.577-2.414 1.429 0 2.589 1.158 2.589 2.588h.006v9.439c0 .087.071.156.16.156h3.179c.086 0 .157-.07.157-.156v-9.44h-.009z",
    transform: "translate(-657 -248) translate(510 206) translate(147 42) translate(0 1) translate(0 .217)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7896D2",
    d: "M94.408 10.34c0-3.36-2.723-6.082-6.082-6.082-1.696 0-3.23.695-4.335 1.818-1.102-1.123-2.636-1.818-4.333-1.818-1.018 0-1.976.25-2.82.692l-.56-.564c-.058-.057-.134-.09-.216-.09h-2.18c-.17 0-.305.138-.305.305v15.03c0 .168.135.304.305.304h2.871c.168 0 .305-.136.305-.304V10.34h.013c0-1.43 1.158-2.588 2.587-2.588 1.43 0 2.587 1.158 2.587 2.588h.01v9.439c0 .087.07.156.156.156h3.179c.087 0 .158-.07.158-.156v-9.613c.09-1.347 1.207-2.414 2.578-2.414 1.43 0 2.59 1.158 2.59 2.588h.006v9.439c0 .087.07.156.158.156h3.18c.086 0 .157-.07.157-.156v-9.44h-.01z",
    transform: "translate(-657 -248) translate(510 206) translate(147 42) translate(0 1) translate(0 .217)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-657 -248) translate(510 206) translate(147 42) translate(0 1) translate(0 .217) translate(40.88 .859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l853sigv6i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#px9k23yvsh"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2837AA",
    d: "M14.402 18.516L7.5 11.107l6.813-7.242c.183-.195.045-.514-.222-.514h-3.11c-.084 0-.164.034-.223.095L4.843 9.732H3.696V.666c0-.09-.072-.162-.163-.162H.456c-.09 0-.162.073-.162.162v18.25c0 .088.072.161.162.161h3.077c.09 0 .163-.073.163-.162v-6.422h1.166l5.999 6.438c.057.062.139.097.223.097h3.095c.267 0 .406-.317.223-.512",
    mask: "url(#l853sigv6i)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredMekomeLogo);
export default __webpack_public_path__ + "static/media/coloredMekomeLogo.a1eaeebf57a227f724ac3d6e240bc4e1.svg";
export { ForwardRef as ReactComponent };